import actions from './actions';
import authActions from '../auth/actions';

export const defaultEtiqueta = {
  widthCm: 5,
  heightCm: 3,
  paddingTopCm: 0.2,
  paddingRightCm: 0.2,
  paddingBottomCm: 0.2,
  paddingLeftCm: 0.2,
  orientation: 'reto',
  showProcedures: true,
  showPlan: true,
  showCardNumber: true,
  showPhone: false,
  showCpf: false,
  forceBlack: false,
  fontSizeHeader: 5,
  fontSizeName: 9,
  fontSizeAge: 5,
  fontSizeDoctor: 5,
  fontSizeExtra: 5,
};

export const defaultFita = {
  widthCm: 11,
  heightCm: 2,
  paddingTopCm: 0.2,
  paddingRightCm: 0.2,
  paddingBottomCm: 0.2,
  paddingLeftCm: 0.2,
  orientation: 'reto',
  showProcedures: true,
  showPlan: true,
  showCardNumber: true,
  showPhone: false,
  showCpf: false,
  forceBlack: false,
  fontSizeHeader: 5,
  fontSizeName: 8,
  fontSizeAge: 5,
  fontSizeDoctor: 5,
  fontSizeExtra: 5,
};

const initState = {
  activeProfile: 'etiqueta',
  etiqueta: { ...defaultEtiqueta },
  fita: { ...defaultFita },
  savingLabelSettings: false,
};

export default function labelSettingsReducer(state = initState, action) {
  switch (action.type) {
    case authActions.CLEAR_STATES:
      return { ...initState };

    case actions.FETCH_LABEL_SETTINGS_SUCCESS:
      return {
        ...state,
        activeProfile: action.payload.activeProfile,
        etiqueta: action.payload.etiqueta,
        fita: action.payload.fita,
      };

    case actions.SET_ACTIVE_PROFILE:
      return {
        ...state,
        activeProfile: action.payload,
      };

    case actions.SAVING_LABEL_SETTINGS:
      return {
        ...state,
        savingLabelSettings: true,
      };

    case actions.SAVE_LABEL_SETTINGS_SUCCESS: {
      const { profile, settings } = action.payload;
      return {
        ...state,
        savingLabelSettings: false,
        [profile]: settings,
      };
    }

    case actions.SAVE_LABEL_SETTINGS_ERROR:
      return {
        ...state,
        savingLabelSettings: false,
      };

    default:
      return state;
  }
}
